import {alertController} from '@ionic/vue';
import {BarcodeScanner as BarcodeScannerPlugin} from '@ionic-native/barcode-scanner';
import EventBus from "@/EventBus";
import axios from 'axios';

class BarcodeScanner {

    constructor(zebra) {
        this.zebra = zebra;
    }

    search(include = 'locations,locations.pivot,skus,image_urls,mpns') {
        return this.scan().then(barcode => {
            return axios
                .get('/api/items', {params: {
                    barcode: barcode.barcode,
                    include: include
                }})
                .then(response => {
                    if (response.data.items.length !== 1) {
                        this.presentAlert(
                            "Non-unique barcode",
                            "Unfortunately, the barcode scanned returns a non-unique result. Please search manually."
                        );
                        return null;
                    } else {
                        return response.data.items[0];
                    }
                }).catch(() => {
                    this.presentAlert(
                        'Search Error',
                        'There was a problem searching by barcode. Please search manually'
                    );
                });
            });
    }

    scan(type = '') {
        if (this.zebra.isReady) {
            return alertController.create({
                header: 'Please scan',
                buttons: ['Cancel'],
                backdropDismiss: false
            }).then(modal => {
                modal.present();

                // return a Promise which resolves when the scanner gets
                // a reading, but rejects when the user hits cancel.
                return new Promise((resolve, reject) => {
                    modal.onDidDismiss().then(response => {
                        if (!response.data) {
                            reject(Error("cancelled"));
                        }
                    });
                    EventBus().emitter.once('zebra.response', (response => {
                        modal.dismiss(true);

                        // this code appears below too, not sure how/ where to refactor
                        const payload = {
                            barcode: response.raw.extras['com.symbol.datawedge.data_string'],
                            type: response.raw.extras['com.symbol.datawedge.label_type'],
                            raw: response.raw
                        }

                        let extra = {};
                        if (type === 'location') {
                            const fields = payload.barcode.split('|');
                            extra = {
                                id: fields[0],
                                code: fields[1]
                            };
                        }
                        payload.extra = extra;
                        resolve(payload);
                    }));
                });
            });
        }

        return BarcodeScannerPlugin.scan({disableSuccessBeep: true}).then(barcodeData => {
            let extra = {};
            if (type === 'location') {
                const fields = barcodeData.text.split('|');
                extra = {
                    id: fields[0],
                    code: fields[1]
                };
            }
            console.log("scanner returning... %o", barcodeData);
            return {
                barcode: barcodeData.text,
                type: barcodeData.format,
                extra: extra
            };
        }).catch(error => {
            console.log("problem with scanner: ", error);
            this.presentAlert(
                'Scanning Error',
                'There was a problem starting the barcode scanner'
            );
        });
    }

    presentAlert(header, message) {
        alertController.create({
            header, message, buttons: ['Ok']
        }).then(alert => alert.present());
    }
}

export default BarcodeScanner;
